import { computed } from "vue";
import { getHooks } from './useHOC'

type DependencyList = ReadonlyArray<unknown>;

const useMemoType = 2

export function useMemo<T>(factory: () => T, deps: DependencyList | undefined) {
  const [hooks, currentHookIndex] = getHooks(useMemoType);
  const hook = hooks?.[currentHookIndex] || computed<T>(factory)
  hooks![currentHookIndex] = hook;
  deps
  return hook.value as T;
}
